<div *ngIf="isActive" class="dp-loading">
<div class="spinner">
  <div eds-spinner large></div>
</div>
  <p class="loading-text" *ngIf="text">
      {{ text }}
  </p>

  <!-- <ng-content></ng-content> -->
</div>